import React from 'react';
import cl from './AboutInfo.module.css';

const AboutInfo = (props) => {
    return (
      <section className={cl.about}>
        <h1>Acerca de nuestra empresa</h1>
        <p>{props.shopStory}</p>
      </section>
    );
}

export default AboutInfo;
